import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Dialog,
  Drawer,
  IconButton,
  useMediaQuery,
  useTheme,
} from '@mui/material';

import GroupSelectPayerContent, {
  GroupSelectPayerContentProps,
} from './GroupSelectPayerContent';
import './styles';

interface GroupSelectPayerModalProps extends GroupSelectPayerContentProps {
  open: boolean;
}

const GroupSelectPayerModal: React.FC<GroupSelectPayerModalProps> = ({
  open,
  onClose,
  onConfirm,
  members,
  selectedPayerId,
  currentUserId,
  expenseTitle,
}) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  if (isDesktop) {
    return (
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          className: 'group-select-payer-dialog',
        }}>
        <IconButton
          aria-label="Close"
          onClick={onClose}
          className="group-select-payer-close">
          <CloseIcon />
        </IconButton>
        <GroupSelectPayerContent
          onClose={onClose}
          onConfirm={onConfirm}
          members={members}
          selectedPayerId={selectedPayerId}
          currentUserId={currentUserId}
          expenseTitle={expenseTitle}
        />
      </Dialog>
    );
  }

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      PaperProps={{
        className: 'group-select-payer-drawer',
      }}>
      <Box className="group-select-payer-handle" />
      <IconButton
        aria-label="Close"
        onClick={onClose}
        className="group-select-payer-close">
        <CloseIcon />
      </IconButton>
      <GroupSelectPayerContent
        onClose={onClose}
        onConfirm={onConfirm}
        members={members}
        selectedPayerId={selectedPayerId}
        currentUserId={currentUserId}
        expenseTitle={expenseTitle}
      />
    </Drawer>
  );
};

export default GroupSelectPayerModal;
